<div class="form-group">
  <wm-help-text
    *ngIf="de.instructions"
    [helpText]="de.instructions"
    placement="right"
    [displayOnly]="true"
  ></wm-help-text>
  <div [innerHTML]="html"></div>
</div>
